import React from 'react';
import { render } from 'react-dom';
// import Appearer from './components/Appearer';
import Header from './components/Header';
import FooterWrapper from './components/FooterWrapper';

const mount = () => {
    const $mountPointHeader = document.querySelector('#sona-header');
    if ($mountPointHeader) {
        const script = $mountPointHeader.querySelector('script');
        let initialState = {};

        if (script) {
            try {
                initialState = JSON.parse(script.innerText);
            } catch (e) {
                console.error(e);
            }
        } else {
            fetch(
                'https://www.sonnenalp.de/data/multilang-header-json.json'
            ).then((res) => {
                if (res.ok) {
                    res.json().then((data) => {
                        render(<Header {...data} />, $mountPointHeader);
                    });
                }
            });
        }

        render(<Header {...initialState} />, $mountPointHeader);
    }
};

// const renderAppearer = () => {
//     const $mountAppearer = document.getElementsByClassName('section');
//     var mounterArray = Array.from($mountAppearer);

//     let arrayListStff =[];
//     if(mounterArray && mounterArray.length > 0) {
//         mounterArray.map((section) => {
//             arrayListStff.push(<section class="section"><Appearer><span  dangerouslySetInnerHTML={{__html: section.innerHTML}} /> </Appearer></section>)
//             return undefined;
//         })

//         render(arrayListStff, document.body)
//     }
// }

// renderAppearer();

const renderFooter = () => {
    const $mountPointFooter = document.querySelector('#sona-footer');

    if ($mountPointFooter) {
        Promise.all([
            fetch('https://www.sonnenalp.de/data/ibefooter'),
            fetch('https://www.sonnenalp.de/data/ibefooteren'),
        ]).then(([resDe, resEn]) => {
            if (resDe.ok && resEn.ok) {
                Promise.all([resDe.text(), resEn.text()]).then(
                    ([dataDe, dataEn]) => {
                        render(
                            <FooterWrapper data={{ en: dataEn, de: dataDe }} />,
                            $mountPointFooter
                        );
                    }
                );
            }
        });
    }
};

const importBuildTarget = () => {
    if (process.env.REACT_APP_BUILD_TARGET === 'apps') {
        return import('./entry-bundle');
    } else if (process.env.REACT_APP_BUILD_TARGET === 'header') {
        mount();
        window.initSonaExternalHeader = mount;
        window.initSonaExternalFooter = renderFooter;
    } else {
        return Promise.reject(
            new Error(
                'No such build target: ' + process.env.REACT_APP_BUILD_TARGET
            )
        );
    }
};

importBuildTarget();



// WEBPACK FOOTER //
// ./src/index.js